/**
 * Populating product images in each unit based on images unit_ids
 */
export const populateProductUnitImages = (productUnits, productImages) => {
    const units = productUnits.map((pu) => {
        const images = {};
        productImages.forEach((pi) => {
            if (pi.unit_ids.includes(pu.unit_id)) {
                images[pi.image_id] = pi;
            }
        });
        const unitImages = Object.values(images).sort((a, b) => a.image_position - b.image_position);
        return {
            ...pu,
            unit_images: unitImages,
        };
    });
    return units;
};
